import { resultsPaths as paths } from "@gss/common/Paths";

export function getBaseName(): string {
    if (window.location.pathname.startsWith(paths.base)) {
        return paths.base;
    }
    return "";
}
